module.exports = "export default leftpad\n\nfunction leftpad (str, len, ch) {\n  //convert the `str` to String\n  str = str + '';\n\n  //needn't to pad\n  len = len - str.length;\n  if (len <= 0) return str;\n\n  //convert the `ch` to String\n  if (!ch && ch !== 0) ch = ' ';\n  ch = ch + '';\n\n  var pad = '';\n  while (true) {\n    if (len & 1) pad += ch;\n    len >>= 1;\n    if (len) ch += ch;\n    else break;\n  }\n  return pad + str;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./side-by-side/example.txt
// module id = 108
// module chunks = 0